/**
 * Tooltip helper utilities
 */

import { isObj, isStr, isNum, isNull, isBool, capitalizeFirstLetter, uncamelize } from '../../core/highcharts-editor';

const blacklist = [
  'headerFormat',
  'pointFormat',
  'footerFormat',
  'id',
  'visible',
  'plotX',
  'plotY',
  'yBottom',
  'formatPrefix',
  'isNull',
  'selected',
  'plotClose',
  'plotOpen',
  'isInside',
  'clientX',
  'negative',
  'zone',
  'barX',
  'pointWidth',
  'shapeType',
  'width',
  'height',
  'plotHigh',
  'plotLow',
  'valueDescription',
  'state'
];

const multiLevel = ['point', 'series'];
const multiLevelProps = [
  'point.name',
  'series.name',
  'point.key',
  'point.from',
  'point.to',
  'point.weight',
  'point.stackTotal',
  'point.stackY',
  'point.stackX',
  'point.low',
  'point.high',
  'point.z',
  'point.extra',
  'point.label',
  'point.formattedValue',
  'point.median',
  'point.q1',
  'point.q3',
  'point.total',
  'point.description',
  'point.value',
  'point.xLabel',
  'point.yLabel'
];

const tooltipOptionsInclude = (options, id) => {
  return options.every((option) => option.value !== id);
};

const recursivelyExtractOptions = (newOptions, option, key) => {
  if (isObj(option)) {
    Object.keys(option).forEach((key) => {
      recursivelyExtractOptions(newOptions, option[key], key);
    });
  } else if (multiLevel.includes(key)) {
    const parentKey = key;
    Object.keys(option).forEach((key) => {
      if (multiLevelProps.includes(parentKey + '.' + key)) {
        recursivelyExtractOptions(newOptions, option[key], parentKey + '.' + key);
      }
    });
  } else if (
    !blacklist.includes(key) &&
    !isNull(option) &&
    tooltipOptionsInclude(newOptions, key) &&
    (isStr(option) || isNum(option) || isBool(option))
  ) {
    let name = capitalizeFirstLetter(uncamelize(key));
    newOptions.push({
      label: name.replace('.', '') + ` (${option})`,
      value: key
    });
  }
};

export const getTooltipOptions = (options) => {
  const newOptions = [];
  recursivelyExtractOptions(newOptions, options);
  return newOptions;
};

export const getPredefinedVar = (options, type) => {
  return options[type] ?? '';
};

// This is created in the everviz repo as it is used in here and the publish codes
export const tooltipFormatter = window.everviz.tooltipFormatter;
